import React, { useMemo } from "react";
import { useLoading } from "app/custom-hooks/loadingHook";
import { PieChartComponent } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/PieChartComponent";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import { i18nFilter } from "app/filters/i18nFilter";
import { CHART_COLORS } from "app/constants/ChartColors";
import type { IWidgetSingleWrapperProps } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";
import { getSingleBrandedNonBranded } from "app/services/WebsiteAnalysis/SearchOverviewApiService";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";

export const BrandedNonBrandedWidgetWrapper: React.FunctionComponent<IWidgetSingleWrapperProps> = (props) => {
    const { apiParams, apiParamsObj, subtitleFilters } = props;
    const { webSource, country, key, isWindow, isWWW, to, from } = apiParams;
    const [BrandedNonBrandedData, BrandedNonBrandedDataOps] = useLoading();
    React.useEffect(() => {
        BrandedNonBrandedDataOps.load(() =>
            getSingleBrandedNonBranded({
                ...apiParamsObj,
            }),
        );
    }, [webSource, country, key, isWindow, isWWW, to, from]);
    const isBrandedNonBrandedLoading = [useLoading.STATES.INIT, useLoading.STATES.LOADING].includes(
        BrandedNonBrandedData.state,
    );
    const isBrandedNonBrandedFetchError = BrandedNonBrandedData.state === useLoading.STATES.ERROR;
    const a2d = () => (
        <AddToDashboard
            metric="BrandedKeywords"
            modelType="fromWebsite"
            type="PieChart"
            webSource={webSource as IWidgetModelTypesWebSource}
        />
    );
    const chartData = useMemo(() => {
        const dataObj = BrandedNonBrandedData.data?.Data?.[apiParams.key];
        if (!dataObj) {
            return null;
        } else {
            const allDevices = dataObj && dataObj["Branded"] + dataObj["NoneBranded"];
            return [
                {
                    data: [
                        {
                            color: CHART_COLORS.DeduplicatedAudience[0],
                            name: i18nFilter()("wwo.searchTraffic.organic.pie.branded"),
                            seriesName: "Branded",
                            y: (dataObj && dataObj["Branded"] / allDevices) * 100,
                        },
                        {
                            color: CHART_COLORS.DeduplicatedAudience[1],
                            name: i18nFilter()("wwo.searchTraffic.organic.pie.notBranded"),
                            seriesName: "NoneBranded",
                            y: (dataObj && dataObj["NoneBranded"] / allDevices) * 100,
                        },
                    ],
                },
            ];
        }
    }, [BrandedNonBrandedData, apiParams]);
    return (
        <PieChartComponent
            isError={isBrandedNonBrandedFetchError}
            isLoading={isBrandedNonBrandedLoading}
            chartData={chartData}
            params={apiParams}
            subtitleFilters={subtitleFilters}
            a2d={a2d}
            title={"analysis.source.search.overview.brandednonbranded"}
            tooltip={"analysis.source.search.overview.brandednonbranded.tooltip"}
            addMarginRight={false}
        />
    );
};
